import './App.css';
import React, { Fragment, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

// Components
import HomePage from './Components/Pages/Home/home';
import Navbar from './Components/Navbar/navbar';
import ContactUs from './Components/Pages/Contact/contact';
// import RxForm from './Components/Pages/RxForm/rx-form';
// import HomeConnectLink from './Components/Pages/PharmaConnect/pharmaconnect';
import Services from './Components/Pages/Services/services';
import ScrollToTop from './Components/scrollToTop';
import AboutPage from './Components/Pages/About/about';
// import Faqs from './Components/Pages/FAQs/faqs';
// import OCP from './Components/Images/OCP.png';
import PrivacyPolicy from './Components/Pages/Privacy/privacy-policy';

function App() {

  const [scrolled, setScrolled] = useState(false);
  const [bannerIndex, setBannerIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const bannerMessages = [
    "Canada wide delivery",
    "Call us today at (905) 577-4000",
  ];

  // Rotate banner messages
  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setBannerIndex((prev) => (prev + 1) % bannerMessages.length);
        setIsAnimating(false);
      }, 500); // Match this to your CSS animation duration

    }, 4000);

    return () => clearInterval(interval);
  }, []);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrolled(window.scrollY > 32); // Adjust to match banner height
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  return (
    <Fragment>
      <Router>
        <ScrollToTop />

        {/* TOP BANNED */}
        <div className={`top-banner ${scrolled ? 'hidden' : ''}`}>
          <div className={`banner-text ${isAnimating ? 'slide-out' : 'slide-in'}`}>
            {bannerMessages[bannerIndex]}
          </div>
        </div>
        {/* <div className={`top-banner ${scrolled ? 'hidden' : ''}`}>
          Canada wide delivery
        </div> */}

        {/* NAVBAR */}
        {/* <nav className={`navbar ${scrolled ? 'navbar-fixed' : ''}`}> */}
        <Navbar />
        {/* </nav> */}

        {/* MAIN CONTENT */}
        <div className={`main-content ${scrolled ? 'scrolled' : ''}`}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/contact" element={<ContactUs />} />
            {/* <Route path="/rx-form" element={<RxForm />} /> */}
            {/* <Route path="/midtown-pharmaconnect" element={<HomeConnectLink />} /> */}
            <Route path="/services" element={<Services />} />
            <Route path='/about' element={<AboutPage />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            {/* <Route path='/faqs' element={<Faqs />} /> */}
          </Routes>
        </div>

        <footer class="footer">
          <a href="https://www.legitscript.com/websites/?checker_keywords=midtownpharmacy.ca" target="_blank" title="Verify LegitScript Approval for www.midtownpharmacy.ca">
            <img src="https://static.legitscript.com/seals/975954.png" alt="Verify Approval for www.midtownpharmacy.ca" width="73" height="79" />
          </a>
          <p id='privacy-policy'>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
          <p id='copyright'>Copyright © 2026 Midtown Medical Pharmacy — All Rights Reserved.</p>
          {/* <p id='copyright'>© 2026 Midtown Medical Pharmacy <br></br>By using this website, you agree to our <Link to="/privacy-policy">Privacy Policy</Link>.</p> */}
        </footer>

      </Router>

    </Fragment>
  );
}

export default App;
